import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './Root';
import './i18n';
import * as serviceWorker from './serviceWorker';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import {Provider} from 'react-redux';
import store from './store';
import firebase from 'firebase'
import {ReactReduxFirebaseProvider} from 'react-redux-firebase'
import {createFirestoreInstance} from 'redux-firestore'


// react-redux-firebase config
const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
}

const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance // <- needed if using firestore
}

ReactDOM.render(
    <I18nextProvider i18n={i18next}>
        <Provider store={store}>
            <Suspense fallback="loading">
                <ReactReduxFirebaseProvider {...rrfProps}>
                    <Root/>
                </ReactReduxFirebaseProvider>
            </Suspense>
        </Provider>
    </I18nextProvider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
